import { AppDate } from '../envTypes';
import { ModelBase } from './base';
import { Profile, ProfileUserType } from './profile';

export interface LoginSession {
  loggedIn: boolean;
  loggedInAt: AppDate;
  deviceId: string;
  deviceModel: string;
  loggedOutAt?: AppDate;
  // same device id used with new session
  abandonedAt?: AppDate;
  lastUsed: AppDate;
  lastUsedAppVersion: string;
  lastUsedAppId: string;
  pushToken?: string;
  hasPushToken: boolean;
  userAgent?: string;
  platform?: string;
}

export enum DeleteAccountApplicationStatus {
  approved = 'approved',
  pending = 'pending',
  rejected = 'rejected',
}

export interface DeleteAccountApplication extends ModelBase {
  message?: string;
  userId: string;
  user: Profile;
  status: DeleteAccountApplicationStatus;
  handlerId?: string;
  handler?: Profile;
}

// /userGroups/{groupId}
// /userGroups/{groupId}/users/{userId}
export interface UserGroup {
  name: string;
  description?: string;
  createdAt: AppDate;
  updatedAt?: AppDate;
  active: boolean;
  sendGridListId?: string;
  userType?: ProfileUserType;
}

export interface InvitationInterface {
  code: string;
  sellerIds: string[];
  couponCodes: string[];
  createdAt?: AppDate;
  enabled: boolean;
}

// privateProfiles/{uid}/inviteBy/{uId}
// invitedBy just have one doc
export type InvitedBy = Profile;
